module.exports = __webpack_public_path__ + "img/Dark-theme.7f7a495e.png";